import { useEffect, useCallback } from 'react';

function Auth({ onProfileDataFetched }) {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;

  const handleLogout = useCallback(() => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/signin";
  }, []);

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        if (!authToken) {
          handleLogout();
          return;
        }

        const response = await fetch(`${baseurl}/profile`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (response.status === 429) {
          console.warn("Rate limit reached. Please wait a moment.");
          return;
        }

        const result = await response.json();

        if (result.status) {
          const userData = result.USER || result.data;
          if (userData) {
            sessionStorage.setItem('adminUser', JSON.stringify(userData));
            sessionStorage.setItem('adminRole', userData.user_role || '');
          }
          if (onProfileDataFetched && typeof onProfileDataFetched === 'function') {
            onProfileDataFetched(userData || result);
          }
        } else {
          handleLogout();
        }
      } catch (error) {
        console.error('Auth verification error:', error);
        handleLogout();
      }
    };

    fetchProfileData();
  }, [authToken, baseurl, handleLogout, onProfileDataFetched]);

  return null;
}

export default Auth;
